import script from "./SettingsBrowserContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsBrowserContent.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsBrowserContent.vue?vue&type=style&index=0&id=54ca7c7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ca7c7c"]])

export default __exports__